import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { addHeaderLoadedListener } from 'services/eventFunctions';
import PageState from 'global_state/state/PageState';
import UserState from 'global_state/state/UserState';


const root = ReactDOM.createRoot(
  document.getElementById('xplore_react_reservations') as HTMLElement
);

root.render(
  <React.StrictMode>
    <PageState>
      <UserState>      
        <App/>
      </UserState>      
    </PageState>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

